module.exports = __webpack_public_path__ + "img/earthbump.ef58250d.jpg";